export interface TipItem {
  id: string;
  icon: string;
  tag: string;
  title: string;
  desc: string;
}

export const tips: TipItem[] = [
  {
    id: "tip-1",
    icon: "ri-flashlight-line",
    tag: "提速",
    title: "提前缓存想看的章节",
    desc: "在稳定的网络下，把想看的漫画章节提前缓存，离线也能顺畅阅读，还能避开高峰时段卡顿。",
  },
  {
    id: "tip-2",
    icon: "ri-gallery-line",
    tag: "画质",
    title: "根据网络调整画质",
    desc: "弱网时切到流畅模式，图片加载明显加快；网络好时再切回高清，享受更细腻的画面。",
  },
  {
    id: "tip-3",
    icon: "ri-timer-line",
    tag: "记录",
    title: "开启阅读进度同步",
    desc: "开启自动同步后，换设备或重装也能找回上次读到的章节，追更不中断。",
  },
  {
    id: "tip-4",
    icon: "ri-settings-3-line",
    tag: "环境",
    title: "定期清理缓存更流畅",
    desc: "长期阅读会积累不少缓存，定期在设置中清理一次，能显著改善翻页卡顿和加载缓慢的问题。",
  },
  {
    id: "tip-5",
    icon: "ri-bookmark-line",
    tag: "收藏",
    title: "用标签管理收藏夹",
    desc: "给收藏的漫画打上标签，想看的、在追的、已完结分门别类，查找更方便。",
  },
  {
    id: "tip-6",
    icon: "ri-keyboard-line",
    tag: "操作",
    title: "巧用快捷键翻页",
    desc: "阅读页面支持键盘左右键翻页，鼠标点击图片两侧也能前进后退，追更效率更高。",
  },
];